import { Component } from "@angular/core";
import { AbstractHistoryChartOverview } from "src/app/shared/components/chart/abstractHistoryChartOverview";

@Component({
  templateUrl: "./details.overview.html",
  standalone: false,
})
export class DetailsOverviewComponent extends AbstractHistoryChartOverview { }
